import type { ReceiptLineInput } from '../types';

/**
 * Line item quantities represent countable units (certificates, months of
 * tithe) on every sampled receipt format — never fractional, never negative.
 * The RPC enforces this server-side too (it's the real trust boundary); this
 * is what keeps the client from ever sending something the server would reject.
 */
export function isValidQuantity(q: string): boolean {
  const n = Number(q);
  return Number.isInteger(n) && n > 0;
}

/** A line the user has started filling in — quantity alone (defaults to '1') doesn't count. */
export function isLineTouched(l: ReceiptLineInput): boolean {
  return !!(l.description.trim() || l.concept_id || l.unit_price.trim());
}

/**
 * The single definition of "ready to submit". Shared by the disabled-Save
 * validation and the actual submit filter, so a line that slipped past one
 * check can never slip into the request through the other.
 */
export function isLineValid(l: ReceiptLineInput): boolean {
  return (
    !!l.description.trim() &&
    isValidQuantity(l.quantity) &&
    l.unit_price.trim() !== '' &&
    parseFloat(l.unit_price) >= 0
  );
}
